<template>
  <div class="block">
    <div class="block-title center">
      <h2 class="alt">{{ computedTitle }}:</h2>
    </div>
    <div class="orders-bag">
      <ExpandTransition>
        <Item v-for="(item, index) in dot.items" :key="index" :dot="dot" :item="item" />
      </ExpandTransition>
      <div class="invalid-text" v-if="totalItemsPrice > maxItemsCost">
        Суммарная стоимость товаров должна быть не более {{ maxItemsCost }} руб.
      </div>
      <div class="invalid-text" v-if="totalItemsWeight > availableWeightValues.at(-1)">
        <span>Слишком большая масса товаров для данного типа доставки.</span>
        <span
          @click.prevent="scrollToDeliveryType"
          @keyup.space="scrollToDeliveryType"
          class="validation-link"
        >
          Смените тип доставки для увеличения максимальной массы.
        </span>
      </div>
      <div class="invalid-text" v-if="totalItemsWeight > maxWeight">
        Масса всех грузов не должна превышать 1.5 тонны.
      </div>
      <span
        v-if="form.itemsLimitInDot > dot.items.length"
        class="addition-info-switcher unselectable"
        @click="addDotItem({ dot })"
        >Добавить груз</span
      >
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from 'vuex'
import { GENERAL_STORE } from '@apps/order-form/src/store'
import Item from './ItemComponent.vue'
import ExpandTransition from '../Transitions/ExpandTransition.vue'

export default {
  name: 'ItemsList',
  props: {
    dot: { type: Object, required: true },
  },
  components: {
    Item,
    ExpandTransition,
  },
  computed: {
    ...mapState(GENERAL_STORE, ['form', 'order']),
    ...mapGetters(GENERAL_STORE, [
      'isBuyout',
      'totalItemsPrice',
      'maxItemsCost',
      'totalItemsWeight',
      'availableWeightValues',
      'maxWeight',
    ]),

    computedTitle() {
      return this.isBuyout ? 'Что выкупаем' : 'Что везем'
    },
  },
  methods: {
    ...mapMutations(GENERAL_STORE, ['addDotItem']),
    scrollToDeliveryType() {
      document.getElementById('auto-component').scrollIntoView({
        behavior: 'smooth',
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.validation-link {
  cursor: pointer;

  color: blueviolet;

  background: none;
  border: none;

  transition: color 0.6s;

  &:hover {
    color: darkcyan;
  }
}
</style>
